module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Readers love")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("R")]), _c('span', {
    staticClass: "t4"
  }, [_vm._v("USSELL")]), _vm._v(" "), _c('span', {
    staticClass: "t3"
  }, [_vm._v("J. S")]), _c('span', {
    staticClass: "t4"
  }, [_vm._v("ANDERS")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("The Book of Ethan")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“"), _c('span', {
    staticClass: "t7"
  }, [_vm._v("The Book of Ethan")]), _vm._v(" was a very enjoyable read that doesn’t easily fit into any specific subgenre... The author definitely has talent.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—Prism Book Alliance")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“I really enjoyed the diversity in this book... I will probably be on the lookout for more from this author.”")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("—Scattered Thoughts and Rogue Words")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Special Effect")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“"), _c('span', {
    staticClass: "t7"
  }, [_vm._v("Special Effect")]), _vm._v(" is a quirky novel: part murder mystery, part coming-of-age tale, and part romance.”")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("—Rainbow Book Reviews")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47993f62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/002.vue
// module id = 57
// module chunks = 0